import { useEffect, useState } from 'react';
import { Col, Form, Spin, Tabs, message } from 'antd';
import { TextService } from '../../Services/TextService';
import LeftMenuCommunicate from './LeftCommunicate';
import { OneFrontDatePicker } from '../../Components/Forms/BookyDatePicker';
import { BookyButton } from '../../Components/Buttons/BookyButton';
import Paragraph from 'antd/lib/typography/Paragraph';
import { EmailTemplateService } from '../../Services/EmailTemplateService';
import { WebApiEmailDtoCommunicationReportDto, WebApiMemberDtoMemberCommunicationHistory } from '../../Repository/eventbookyapi';
import { BookyInput } from '../../Components/Forms/BookyInput';
import AdminEmailLogsTable from './EmailLogsTable';
import CommunicationHistoryTable from './CommunicationHistoryTable';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { BookyCheckbox } from '../../Components/Forms/BookyCheckbox';
import { MemberService } from '../../Services/MemberService';
import dayjs from 'dayjs';

const AdminEmailFollowUp = () => {
    const [logs, setLogs] = useState([] as WebApiEmailDtoCommunicationReportDto[]);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const [history, setHistory] = useState([] as WebApiMemberDtoMemberCommunicationHistory[]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [historyLoaded, setHistoryLoaded] = useState(false);

    const GetText = TextService.GetText;

    useEffect(() => {
        form.setFieldValue('startDate', dayjs().add(-7, 'days'));
        form.setFieldValue('endDate', dayjs());
        searchLogs();
    }, []);

    const searchLogs = async () => {
        const a = dayjs(form.getFieldValue('startDate'));
        const b = dayjs(form.getFieldValue('endDate'));

        if (b.diff(a, 'days') < 0 || b.diff(a, 'days') > 90) {
            message.error(GetText('EmailLogs_Max90Days'));
            return;
        }

        setIsLoading(true);
        const result = await EmailTemplateService.GetEmailLogs({
            start: form.getFieldValue('startDate'),
            end: form.getFieldValue('endDate'),
            email: form.getFieldValue('email'),
            onlyError: form.getFieldValue('onlyError'),
        });
        setIsLoading(false);
        setLogs(result.events ?? []);
    };

    const loadHistory = async () => {
        setHistoryLoading(true);
        try {
            const data = await MemberService.GetCommunicationHistory();
            const sorted = [...(data || [])].sort(
                (a, b) => new Date(b.sent || 0).getTime() - new Date(a.sent || 0).getTime()
            );
            setHistory(sorted);
            setHistoryLoaded(true);
        } catch {
            message.error(TextService.GetText('CommunicationHistory_LoadFailed'));
        }
        setHistoryLoading(false);
    };

    const onTabChange = (key: string) => {
        if (key === 'archive' && !historyLoaded) {
            loadHistory();
        }
    };

    const tabItems = [
        {
            key: 'followup',
            label: GetText('EmailLogs_EmailLogsTitle'),
            children: (
                <>
                    <Paragraph>{GetText('EmailLogs_SearchBelow')}</Paragraph>
                    <Form form={form} colon={false} labelAlign="left" layout="vertical">
                        <Col span={24}>
                            <BookyInput label={GetText('EmailLogs_Email')} name="email" placeholder={GetText('EmailLogs_Email')} />
                            <OneFrontDatePicker label={GetText('EmailLogs_StartDate')} name="startDate" placeholder={GetText('EmailLogs_StartDate')} />
                            <OneFrontDatePicker label={GetText('EmailLogs_EndDate')} name="endDate" placeholder={GetText('EmailLogs_EndDate')} />
                            <BookyCheckbox alignLabelRight={true} label={GetText('EmailLogs_ShowOnlyError')} name="onlyError" />
                            <Form.Item>
                                <BookyButton type="primary" fullWidth={false} text={GetText('EmailLogs_Search')} onClick={searchLogs} />
                            </Form.Item>
                            {!isLoading ? <AdminEmailLogsTable logs={logs} isLoading={isLoading} /> : <Spin />}
                        </Col>
                    </Form>
                </>
            ),
        },
        {
            key: 'archive',
            label: GetText('CommunicationHistory_MenuTitle'),
            children: (
                <>
                    <Paragraph>{GetText('CommunicationHistory_Description')}</Paragraph>
                    <CommunicationHistoryTable history={history} isLoading={historyLoading} />
                </>
            ),
        },
    ];

    return (
        <LayoutLeftMenu title="E-post/sms uppföljning" menu={<LeftMenuCommunicate selected="emailFollowUp" />}>
            <Tabs defaultActiveKey="followup" items={tabItems} onChange={onTabChange} />
        </LayoutLeftMenu>
    );
};

export default AdminEmailFollowUp;
